import Home from './components/Home.vue'
import store from '@/vuex/store'

const router = {
  name: 'home',
  path: '/',
  component: Home,
  meta: {
    titleHeader: 'home'
  },
  beforeEnter: (to, from, next) => {    
    window.location.href = window.location.origin + '/v3/';
    return;
  },
}

export default router